/* eslint-disable react-hooks/rules-of-hooks */
import { useRoutes } from 'react-router-dom'

import BackToSchoolSurvey from '../components/backToSchoolSurvey'
import BerkeleyHousingFairSurvey from '../components/berkeleyHousingFairSurvey'
import Form from '../components/form/versions'
import RooftopPartySurvey from '../components/rooftopPartySurvey'
import ScheduleTour from '../components/scheduleTour'
import ScheduleTourV2 from '../components/scheduleTourV2'
import TourDetail from '../components/tourDetail'
import UscSpring27Survey from '../components/uscSpring27Survey'
import WechatSurvey from '../components/wechatSurvey'

const getAuthRoutes = () =>
  useRoutes([
    {
      path: '/form',
      element: <Form />,
      children: [],
    },
    {
      path: '/scheduleTour/:questionnaireId/:signature/:organizationId/:version/:channel',
      element: <ScheduleTour />,
    },
    {
      path: '/scheduleTourV2/:questionnaireId/:signature/:organizationId/:version/:channel',
      element: <ScheduleTourV2 />,
    },
    {
      path: '/tourDetail/:tourId',
      element: <TourDetail />,
    },
    {
      path: '/wechat-survey',
      element: <WechatSurvey />,
    },
    {
      path: '/back-to-school-survey',
      element: <BackToSchoolSurvey />,
    },
    {
      path: '/rooftop-party-survey',
      element: <RooftopPartySurvey />,
    },
    {
      path: '/berkeley-housing-fair-survey',
      element: <BerkeleyHousingFairSurvey />,
    },
    {
      path: '/usc-spring27-survey',
      element: <UscSpring27Survey />,
    },
  ])

const AuthRoutes = () => getAuthRoutes()
export default AuthRoutes
